export const PERIODIC_CATEGORIES = ['bollette', 'affitto'];
export const EXTRA_CATEGORIES = ['materiali', 'manutenzione', 'marketing', 'tasse_commissioni', 'altro'];

export const MOCK_REVENUE = [3200, 2100, 1900, 3600];

export const MOCK_WORKERS = [
  { id: 'p1', name: 'Marco', fatturatoMese: 3200 },
  { id: 'p2', name: 'Luca', fatturatoMese: 2100 },
  { id: 'p3', name: 'Sara', fatturatoMese: 1900 },
  { id: 'p4', name: 'Giulia', fatturatoMese: 3600 },
];

export const createMockExpenses = () => [
  { id: 1, tipo: 'staff', data: '2026-07-01', poltronaId: 'p1', importoBase: 1050, bonusPct: 8, stato: 'pagato' },
  { id: 2, tipo: 'staff', data: '2026-07-01', poltronaId: 'p2', importoBase: 980, bonusPct: 5, stato: 'pagato' },
  { id: 3, tipo: 'operativa', data: '2026-07-03', categoria: 'affitto', importo: 950, stato: 'pagato', note: 'Affitto locale', periodica: true, periodicaOgni: 1, periodicaFine: '2026-12' },
  { id: 4, tipo: 'operativa', data: '2026-07-08', categoria: 'bollette', importo: 210, stato: 'pagato', note: 'Luce e gas', periodica: true, periodicaOgni: 1, periodicaFine: '2026-12' },
  { id: 5, tipo: 'operativa', data: '2026-07-18', categoria: 'materiali', importo: 95, stato: 'pagato', note: 'Shampoo' },
  { id: 6, tipo: 'staff', data: '2026-08-01', poltronaId: 'p1', importoBase: 1050, bonusPct: 8, stato: 'pagato' },
  { id: 7, tipo: 'staff', data: '2026-08-01', poltronaId: 'p2', importoBase: 980, bonusPct: 5, stato: 'pagato' },
  { id: 8, tipo: 'staff', data: '2026-08-01', poltronaId: 'p3', importoBase: 820, bonusPct: 0, stato: 'pagato' },
  { id: 9, tipo: 'operativa', data: '2026-08-03', categoria: 'affitto', importo: 950, stato: 'pagato', note: 'Affitto locale', periodica: true, periodicaOgni: 1, periodicaFine: '2026-12' },
  { id: 10, tipo: 'operativa', data: '2026-08-05', categoria: 'materiali', importo: 180, stato: 'da_pagare', note: 'Prodotti per capelli' },
  { id: 11, tipo: 'operativa', data: '2026-08-10', categoria: 'marketing', importo: 75, stato: 'da_pagare', note: 'Sponsorizzazione Instagram' },
  { id: 12, tipo: 'operativa', data: '2026-08-12', categoria: 'bollette', importo: 190, stato: 'da_pagare', note: 'Luce' },
];
